import {
  Button,
  Center,
  CircularProgress,
  CircularProgressLabel,
  Flex,
  Icon,
  Image,
  Text,
} from '@chakra-ui/react'
import GlobalMic3 from '@components/GlobalMic3'
import SnailIcon from '@assets/svgs/snail.svg'
import VolumeIcon from '@assets/svgs/learn/volume_2.svg'
import {useEffect, useState} from 'react'
import {CommonColors} from '@utils/CommonStyles'
import {ReactComponent as EyeIcon} from '@assets/svgs/eye.svg'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import {useDispatch, useSelector} from 'react-redux'
import {updateAudio, updateType} from '@redux/paraphrase/paraphraseSlice'
import {ParaphraseType} from '.'
import appRequest from '@apis/app'

const Pronuciation = () => {
  const {paraphraseData} = useSelector((state: any) => state.paraphrase)
  const [speechData, setSpeechData] = useState<any>()
  const [isLoading, setIsLoading] = useState(false)
  const [showHint, setShowHint] = useState(false)
  const [recordingCount, setRecordingCount] = useState(0)
  const [isRecording, setIsRecording] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    const audioData = {
      time: Date.now(),
      url: 'https://smedia.stepup.edu.vn/ielts/audio/paraphrase/AC8_hay_phat_am_prp.wav',
    }
    dispatch(updateAudio(audioData))
  }, [])

  const getColorByScore = (score: any) => {
    if (score >= 75) return '#45BB66'
    if (score >= 50) return '#FFCD00'
    return '#E55856'
  }

  const handlePlayAudio = (url: string, speed: number) => {
    const audioData = {
      time: Date.now(),
      url: url,
      speed: speed,
    }
    dispatch(updateAudio(audioData))
  }

  const handlePauseAudio = () => {
    const audioData = {
      time: Date.now(),
      url: '',
    }
    dispatch(updateAudio(audioData))
  }

  const handleRecordingComplete = async (blob: any) => {
    try {
      setIsLoading(true)
      setIsRecording(false)
      let file = new File([blob], 'audio.wav', {type: 'audio/wav'})
      const formData = new FormData()
      formData.append('audio-file', file)
      formData.append(
        'text-refs',
        paraphraseData?.practice_speaking?.paraphrased_sentence,
      )
      const res = await appRequest.getSpeechCheck(formData)
      setSpeechData(res?.data?.data)
      setRecordingCount(prev => prev + 1)
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  const handleStartRecording = () => {
    setIsRecording(true)
    handlePauseAudio()
  }

  return (
    <Flex
      flexDirection={'column'}
      alignItems={'center'}
      h={'100%'}
      bg={'#fff'}
      p={{base: '16px', md: '32px'}}
      borderRadius={'24px'}>
      <Text
        fontSize={{base: '16px', md: '18px'}}
        color={CommonColors.primary}
        mt={{base: '16px', md: '32px'}}
        textAlign="center">
        HÃY PHÁT ÂM CÂU ĐÃ PARAPHRASE CỦA CÂU DƯỚI
      </Text>

      <Flex
        mt={{base: '20px', md: '40px'}}
        flexDirection={'column'}
        flex={1}
        alignItems={'center'}>
        <CircularProgress
          value={Math.floor(speechData?.total_score * 100) || 0}
          color={getColorByScore(Math.floor(speechData?.total_score * 100))}
          size={'128px'}
          thickness="4px">
          <CircularProgressLabel
            fontSize={{base: '48px', md: '64px'}}
            fontWeight={600}
            color={
              speechData
                ? getColorByScore(Math.floor(speechData?.total_score * 100))
                : '#edebe9'
            }>
            {speechData ? Math.floor(speechData?.total_score * 100) : 0 || '--'}
          </CircularProgressLabel>
        </CircularProgress>
        {speechData && (
          <Flex mt={{base: '16px', md: '32px'}} gap={{base: '8px', md: '12px'}}>
            <Center
              cursor={isRecording ? 'not-allowed' : 'pointer'}
              h={{base: '48px', md: '64px'}}
              w={{base: '72px', md: '96px'}}
              borderRadius={'24px'}
              bg={'rgba(236, 239, 241, 0.50)'}
              opacity={isRecording ? 0.5 : 1}
              onClick={() => {
                if (!isRecording) {
                  handlePlayAudio(
                    paraphraseData?.practice_speaking?.audio_url,
                    1,
                  )
                }
              }}>
              <Image src={VolumeIcon} w={{base: '24px', md: '32px'}} />
            </Center>
            <Center
              cursor={isRecording ? 'not-allowed' : 'pointer'}
              h={{base: '48px', md: '64px'}}
              w={{base: '72px', md: '96px'}}
              borderRadius={'24px'}
              bg={'rgba(236, 239, 241, 0.50)'}
              opacity={isRecording ? 0.5 : 1}
              onClick={() => {
                if (!isRecording) {
                  handlePlayAudio(
                    paraphraseData?.practice_speaking?.slow_audio_url,
                    1,
                  )
                }
              }}>
              <Image src={SnailIcon} w={{base: '24px', md: '32px'}} />
            </Center>
          </Flex>
        )}

        <Text
          fontSize={{base: '18px', md: '24px'}}
          mt={{base: '20px', md: '40px'}}
          textAlign={'center'}>
          {paraphraseData?.practice_speaking?.origin_sentence}
        </Text>
        <Text
          fontSize={{base: '14px', md: '16px'}}
          mt={{base: '8px', md: '16px'}}
          color={'#7C7C7C'}
          textAlign={'center'}>
          {paraphraseData?.practice_speaking?.sentence_vi}
        </Text>
        {showHint && !speechData?.result && (
          <Text
            fontSize={{base: '18px', md: '24px'}}
            mt={{base: '8px', md: '16px'}}
            color={'rgba(60, 60, 67, 0.60)'}
            textAlign={'center'}>
            {paraphraseData?.practice_speaking?.paraphrased_sentence}
          </Text>
        )}
        {speechData?.result && (
          <Text
            fontSize={{base: '18px', md: '24px'}}
            mt={{base: '8px', md: '16px'}}
            textAlign={'center'}>
            {speechData?.result?.map((word: any, index: number) => (
              <Text key={index} as={'span'}>
                {word.letters.map((char: any, index: any) => (
                  <Text
                    key={index}
                    as={'span'}
                    color={getColorByScore(char.score * 100)}>
                    {char.letter}
                  </Text>
                ))}{' '}
              </Text>
            ))}
          </Text>
        )}
        <Center
          gap={{base: '16px', md: '40px'}}
          w={'100%'}
          mt={{base: '20px', md: '40px'}}
          flexWrap="wrap">
          <Button
            h={{base: '40px', md: '48px'}}
            w={{base: '110px', md: '130px'}}
            borderRadius={'99px'}
            color={CommonColors.primary}
            border={`1px solid ${CommonColors.primary}`}
            bg={'#fff'}
            onClick={() => setShowHint(true)}
            isDisabled={showHint || speechData}
            leftIcon={
              <Icon
                as={EyeIcon}
                w={{base: '16px', md: '20px'}}
                h={{base: '16px', md: '20px'}}
              />
            }
            opacity={showHint || speechData ? 0.5 : 1}
            _hover={{opacity: showHint || speechData ? 0.5 : 0.8}}
            fontSize={{base: '14px', md: '16px'}}>
            Gợi ý
          </Button>
          <GlobalMic3
            isLoading={isLoading}
            handleStartRecording={handleStartRecording}
            handleRecordingComplete={handleRecordingComplete}
          />
          <GlobalButton
            h={{base: '40px', md: '48px'}}
            w={{base: '110px', md: '130px'}}
            borderRadius={'99px'}
            fontWeight={600}
            fontSize={{base: '14px', md: '16px'}}
            isDisabled={
              !(
                Math.floor(speechData?.total_score * 100) >= 60 ||
                recordingCount >= 2
              )
            }
            onClick={() => {
              dispatch(updateType(ParaphraseType.SUMMARY))
              handlePauseAudio()
            }}>
            Hoàn thành
          </GlobalButton>
        </Center>
      </Flex>
    </Flex>
  )
}

export default Pronuciation
